export const ROUTES = {
  '/': {
    // Landing is no longer a flag on a route — see ANONYMOUS_LANDING_ROUTE and
    // getLandingRoute at the bottom of this file.
    '/:dealerId/inventory': {
      title: 'All Cars',
      icon: 'car',
      showInMainNav: true,
    },
    '/:dealerId/about': {
      title: 'About Us',
      icon: 'info-circle',
    },
    '/:dealerId/me': {
      title: 'My Profile',
      icon: 'user',
    },
    '/:dealerId/signout': {
      // TODO vet this
      title: 'Sign out',
    },
    // Dashboards & Reports dropdown (FSCRUM-1968). Carries no `permissions`
    // of its own: `canDo` in Nav/NavLink is an AND over the list, so gating the
    // parent on every child's claim would hide the whole menu — Customer
    // Listings included — from a rooftop holding only `rooftop.leads/list`.
    // Each child gates itself instead, and the ungated entries keep the menu
    // from ever rendering empty for a logged-in user.
    '/:dealerId/reports': {
      requireLogin: true,
      showInMainNav: true,
      title: 'Dashboards & Reports',
      menu: {
        // Day-to-day working views first, reporting below the divider.
        '/:dealerId/clp': {
          title: 'Customers & Leads',
          permissions: ['rooftop.leads/list'],
        },

        '/:dealerId/appointments': {
          title: 'Service Appointments',
          permissions: ['rooftop.config/appointments-dashboard'],
        },

        hr1: {},

        // Gated on `rooftop.config/reports`, matching the canonical
        // /engagement-report and /loyalty routes below and the sibling 20 Group
        // Report and Downloads entries. The finer-grained
        // rooftop.config/{loyalty,engagement}-dashboard claims these carried
        // are granted by no role in ft-api's user handler, so `canDo` was
        // always false and both links rendered for nobody.
        '/:dealerId/reports/loyalty': {
          title: 'Loyalty Report',
          permissions: ['rooftop.config/reports'],
        },

        '/:dealerId/reports/engagement': {
          title: 'Engagement Report',
          permissions: ['rooftop.config/reports'],
        },

        '/:dealerId/20-group-report': {
          title: '20 Group Report',
          permissions: ['rooftop.config/reports'],
        },

        // Ungated on purpose — every other entry carries a claim, so this is
        // what keeps the dropdown from rendering empty for a logged-in user.
        '/:dealerId/stats': {
          title: 'illumiQUOTE Report',
        },

        '/:dealerId/downloads': {
          title: 'Downloads',
          permissions: ['rooftop.config/reports'],
        },
      },
    },
    '/:dealerId/engagement-report': {
      requireLogin: true,
      title: 'Engagement Report',
      permissions: ['rooftop.config/reports'],
    },
    '/:dealerId/loyalty': {
      requireLogin: true,
      title: 'Loyalty Report',
      permissions: ['rooftop.config/reports'],
    },
    '/:dealerId/loyalty-group': {
      requireLogin: true,
      title: 'Group Loyalty Trends',
      permissions: ['rooftop.config/reports'],
    },
    '/:dealerId/20-group-report': {
      requireLogin: true,
      title: '20 Group Report',
      permissions: ['rooftop.config/reports'],
    },
    '/:dealerId/settings': {
      title: ({ userName }) => userName,
      icon: 'cog',
      showInUtilNav: true,
      requireLogin: true,
      menu: {
        '/:dealerId/settings/': {
          title: 'Settings',
          icon: 'cog',
          permissions: ['rooftop.config/quote'],
        },

        hr2: {},

        '/:dealerId/customerView/': {
          title: 'Customer View Toggle',
          noFollow: true,
          onClick: ({ toggleQueryValue }) => toggleQueryValue('customerView'),
        },
        '/rooftopChooser': {
          title: 'Change Rooftop',
          noFollow: true,
          filter: ({ rooftopOptions = [] }) =>
            rooftopOptions && rooftopOptions.length > 1,
          onClick: ({ toggleQueryValue }) =>
            toggleQueryValue('showRooftopModal'),
        },
        hr3: {},
        'https://www.vehiclelyfe.com/support/': {
          title: 'Get Help...',
          external: true,
        },
        'https://meetings.hubspot.com/jason-sparks/monthly-reporting?uuid=97da3496-e4ca-4fb0-9d87-a99857e53b81': {
          title: 'Schedule time to learn...',
          external: true,
        },
        '/:dealerId/signout': {
          title: 'Sign out',
          onClick: ({ signOut }) => signOut(),
          noFollow: true,
        },
      },
    },
    '/:dealerId': {},
    '/:dealerId/': {},
    '/:dealerId/404': {},
    '/:dealerId/500': {},
    '/:dealerId/q/:shortCode': {},
    '/:dealerId/b/:shortCode': {},
    '/:dealerId/l/:shortCode': {},
    '/:dealerId/vehicle/:id/:condition': {},
    '/:dealerId/vehicle/:id/:condition/:year': {},
    '/:dealerId/vehicle/:id/:condition/:year/:make': {},
    '/:dealerId/vehicle/:id/:condition/:year/:make/:model': {},
    '/:dealerId/vehicle/:id/:condition/:year/:make/:model/:trim': {},
    '/:dealerId/vehicle/:id': {},
    '/:dealerId/lead/:sessionId': {},
    '/:dealerId/customer/by-session/:sessionId': {
      requireLogin: true,
      title: 'Customer Details',
    },
    '/:dealerId/customer/by-dms-link/:dmsLinkId/:dmsLinkType/:dmsRole': {
      requireLogin: true,
      title: 'Customer Details',
    },
    '/:dealerId/customer/:customerId': {
      requireLogin: true,
      title: 'Customer Details',
    },
    // Surfaced as of FSCRUM-1968 — linked from the Dashboards menu above rather
    // than flagged showInMainNav here, so it stays out of the top-level nav.
    '/:dealerId/clp': {
      requireLogin: true,
      title: 'Customer Listing',
      permissions: ['rooftop.leads/list'],
    },
    '/:dealerId/*': {},
    // TODO these below are the Helix routes, these should probably be a separate
    // export to prevent collisions in the future, but for now it's alright
    '/rooftops': {},
    '/tenants': {},
    '/websties': {},
    '/feeds': {},
    '/homenet': {},
    '/insuranceiq': {},
  },
}

export const ROOTS = ROUTES['/']

// --- Rooftop landing -------------------------------------------------------
//
// `/:dealerId` and `/:dealerId/` name a rooftop, not a page. These are the two
// pages that stand in for "the rooftop itself" — and every other place that
// means the same thing (the nav logo, the rooftop chooser, `goHome`) resolves
// through getLandingRoute rather than hardcoding one of them.
//
// Templates, not URLs: substitute the rooftop with `withRooftop` (or
// `getRouteWithRooftop` when you have state).
//
// ROOFTOP_ROOT_ROUTE is what `router.route` resolves to for `/:dealerId` AND
// `/:dealerId/`, and for nothing else — a rooftop path with anything after it
// resolves to its own route, or to the `/:dealerId/*` catch-all with the
// remainder in `params._`. That distinction is what keeps the landing redirect
// off decorated inbound URLs; see RooftopLanding.
export const ROOFTOP_ROOT_ROUTE = '/:dealerId'
export const ANONYMOUS_LANDING_ROUTE = '/:dealerId/inventory'
export const LOGGED_IN_LANDING_ROUTE = '/:dealerId/clp'

// The whole landing policy, deliberately a hardcoded two-liner: logged in -> the
// CLP, anonymous -> inventory. `can` is the same claim check the nav runs
// (`hasWrite`), so a logged-in user whose role doesn't carry the CLP's
// `permissions` lands on inventory instead of a page they can't use.
//
// This function is the seam. When landing becomes role-driven, rooftop-config
// driven or permission-driven, it grows arguments and callers don't change —
// they already ask it rather than deciding for themselves.
export const getLandingRoute = ({ isLoggedIn, can = () => true } = {}) => {
  if (!isLoggedIn) return ANONYMOUS_LANDING_ROUTE

  const { permissions = [] } = ROOTS[LOGGED_IN_LANDING_ROUTE] || {}

  return permissions.every(can)
    ? LOGGED_IN_LANDING_ROUTE
    : ANONYMOUS_LANDING_ROUTE
}

export const withRooftop = (route, rooftopId) =>
  route ? route.replace(':dealerId', rooftopId) : ''

export const NAV_ROUTES = Object.keys(ROOTS).reduce(
  (ret, k) =>
    ROOTS[k].showInMainNav || ROOTS[k].showInUtilNav
      ? { ...ret, [k]: ROOTS[k] }
      : ret,
  {},
)

export const createNavFilter = (navItems, props) => {
  return k => {
    const requiresLogin = Boolean(navItems[k].requireLogin),
      hasFilter = Boolean(navItems[k].filter),
      passesFilterCheck = Boolean(
        navItems[k].filter && navItems[k].filter(props),
      ),
      passesLoginCheck = Boolean(navItems[k].requireLogin && props.isLoggedIn)

    return (
      (!requiresLogin && !hasFilter) || passesFilterCheck || passesLoginCheck
    )
  }
}

export default ROUTES
